import { Collapse } from "antd";
import { memo } from "react";

import { DisplayModes } from "../js/constants";
import "./Legend.css";

const Legend = memo(({ colorBy, areAlertsVisible }) => {
  const body = (
    <div className="legend">
      <h3>Graphe routier</h3>
      <section>
        <div className="gradient-container">
          <svg width="5" height="50" xmlns="http://www.w3.org/2000/svg">
            <title>Legend entry for congested road segments</title>
            <defs>
              <linearGradient id="verticalGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#FF0000" />
                <stop offset="50%" stopColor="#FFF200" />
                <stop offset="100%" stopColor="#1E9600" />
              </linearGradient>
            </defs>
            <rect
              x="0"
              y="0"
              width="5"
              height="50"
              fill="url(#verticalGradient)"
            />
          </svg>
          {colorBy === "congestion_rate" && (
            <div className="ticks">
              <div>100%</div>
              <div>0%</div>
            </div>
          )}
        </div>
        <div>{DisplayModes[colorBy]}</div>
        <div>
          <svg width="30" height="20">
            <title>Legend entry for closed roads</title>
            <line
              x1="0"
              y1="10"
              x2="30"
              y2="10"
              stroke="black"
              strokeWidth="2"
            />
            <line x1="10" y1="5" x2="20" y2="15" stroke="red" strokeWidth="3" />
            <line x1="10" y1="15" x2="20" y2="5" stroke="red" strokeWidth="3" />
          </svg>
        </div>
        <div>Blocage</div>
        <div>
          <svg width="30" height="20">
            <title>Legend entry for waze segments</title>
            <line
              x1="0"
              y1="10"
              x2="30"
              y2="10"
              stroke="blue"
              strokeWidth="3"
            />
            <line
              x1="17.5"
              y1="10"
              x2="12.5"
              y2="15"
              stroke="blue"
              strokeWidth="2"
            />
            <line
              x1="17.5"
              y1="10"
              x2="12.5"
              y2="5"
              stroke="blue"
              strokeWidth="2"
            />
          </svg>
        </div>
        <div>Géométrie Waze</div>
      </section>

      {areAlertsVisible && (
        <>
          <h3>Alertes</h3>
          <section>
            <img src="fleet_64px.png" alt="bouchon" />
            <div>Congestion inhabituelle</div>
            <img src="car-accident_64px.png" alt="accident" />
            <div>Accident</div>
            <img src="sign_64px.png" alt="danger/incident" />
            <div>Danger / incident</div>
            <img src="hazardous_64px.png" alt="alerte méteo" />
            <div>Alerte météo</div>
            <img src="close_64px.png" alt="fermé" />
            <div>Route barrée</div>
            <img src="question-mark_64px.png" alt="inconnu" />
            <div>Autre évènement</div>
          </section>
        </>
      )}
    </div>
  );

  return (
    <div className="legend-wrap">
      <Collapse
        size="small"
        accordion={false}
        collapsible="header"
        defaultActiveKey={["1"]}
        bordered={false}
        items={[
          {
            key: "1",
            label: <span style={{ fontSize: "16px" }}>Légende</span>,
            children: body,
          },
        ]}
        style={{ background: "white", height: "100%" }}
      />
    </div>
  );
});

export default Legend;
